import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppliedToplineItem } from 'generated/graphql';

import { ToplineAddClickedEvent } from '../ToplineAddClickedEvent';

@Component({
  selector: 'app-topline-preferred-language',
  templateUrl: './topline-preferred-language.component.html',
})
export class ToplinePreferredLanguageComponent  {
  @Input() topline: Partial<AppliedToplineItem> | any;
  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';

  /** Will be used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<ToplineAddClickedEvent>();

  constructor() { }

  // Return languages array, defaulting to empty array when unavailable
  get entityLanguages(): any[] {
    return this.topline?.appliedToplineValue?.entityLanguages ?? [];
  }

  // Always show preferred languages first
  get languagesSortedAll(): any[] {
    return [...this.entityLanguages].sort((a, b) => {
      const ap = !!a?.preferred;
      const bp = !!b?.preferred;
      if (ap === bp) return 0;
      return ap ? -1 : 1;
    });
  }

  // When truncated, only show the first 3 languages
  get languagesSortedTruncated(): any[] {
    return this.languagesSortedAll.slice(0, 3);
  }

  onAddClicked() {
    const eventData = { targetType: this.targetType, targetId: this.targetId, topline: this.topline };
    this.addClick.emit(eventData);
  }
}
